import { environment } from "../../../environments/environment";
import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AppConstants } from "./app-constants";

export class BarChartConstants {
  barChartImgFolderPath: string = "../../../assets/ImagesShapshot/BarChart/";
  /*baseUrl: string = environment.baseUrl;*/
  barChartModuleRoutePath = AppConstants.barChartCategoryPathMap.chartModuleRoutePath + "/";
  chartDescriptions: any = this.getChartDescriptions();
  barChartModuleComponentPath: string = AppConstants.barChartCategoryPathMap.moduleFolderPath;

  //contains the details of all kinds of bar charts that is available in th tool
  barChartTypes: ChartSelectionCard[] = [
  
     {
       "imgUrl": "",
       routePath: this.barChartModuleRoutePath + "BarChart1Custom",
       routePath2: this.barChartModuleRoutePath + "BarChart1Custom",
       description: [],
       chartFolderPath: this.barChartModuleComponentPath + "barchart01",
       chartFolderPath2: this.barChartModuleComponentPath + "barchart01",
       imgClassName: "verticalBarImg",
       chartTitle: "Vertical Bar Chart",
       chartId: 1,
       chartSelectedNumber: 0,
       isEnabled: true,
       chartGroup: "Bar chart"
     },
    {
      "imgUrl": "",
      routePath: this.barChartModuleRoutePath + "BarChart4Custom",
      routePath2: this.barChartModuleRoutePath + "BarChart20",
      description: [],
      chartFolderPath: this.barChartModuleComponentPath + "barchart18",
      chartFolderPath2: this.barChartModuleComponentPath + "barchart20",
      imgClassName: "verticalClusterBarImg",
      chartTitle: "Vertical Cluster Bar",
      chartId: 2,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Bar chart"
    },
   
    {
      "imgUrl": "",
      routePath: this.barChartModuleRoutePath + "BarChart2Custom",
      routePath2: this.barChartModuleRoutePath + "BarChart16",
      description: [],
      chartFolderPath: this.barChartModuleComponentPath + "barchart14",
      chartFolderPath2: this.barChartModuleComponentPath + "barchart16",
      imgClassName: "horizontalBarImg",
      chartTitle: "Horizontal Bar Chart",
      chartId: 3,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Bar chart"
    },
    {
      "imgUrl": "",
      routePath: this.barChartModuleRoutePath + "BarChart3Custom",
      routePath2: this.barChartModuleRoutePath + "BarChart19",
      description: [],
      chartFolderPath: this.barChartModuleComponentPath + "barchart17",
      chartFolderPath2: this.barChartModuleComponentPath + "barchart19",
      imgClassName: "horizontalClusterBarImg",
      chartTitle:  "Horizontal Cluster Bar",
      chartId: 4,
      isEnabled: true,
      chartGroup: "Bar chart"
    },

  ]

  //Returns the descriptions that has to be displayed in customization section of each bar chart
  getChartDescriptions() {
    let genericDescription = [
      "Bar color could be single solid colour, solid multicolour, linear gradient.",
      "Grid lines in both x-axis and y-axis can be solid, long dash, short dash etc. \
          according to the requirements and can be provided with different styles.",
      "On x-axis text, images can be added."
    ];
    let chartDescription = {
      barChart1: [
        "Colour of the bar can be solid single colour, solid multicolour or linear gradient.",
        "X-axis line can be in solid or any styled format.",
        "Each bar chart can be called out.",
        "Grid lines in y axis can be styled in any way.",
        "Shadow can be applied on the bar.",
        "Data label can be fixed position or absolute position (above each bar chart).In data label \
          you can add text, formatter (text or glyph font icon).",
        "Bar texture (repeated pattern) can be applied."
      ],

      barChart2: [
        ...genericDescription,
        "Data Labels - For the different colour on top of columns formatter is used \
          that returns value as well as the colour from the data."
      ],

      genericBarChartDescription:genericDescription
    }

    return chartDescription;
  }


}
export const barChartConstants = new BarChartConstants();
